import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region NUMBER

function _Number(props) {
    const data = props.data || {};
    const hasValue = !Utilities.isNullOrWhitespace(data.Number);
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />
}
const Number = withLabelTokenParsing(_Number, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Invoice.Number:
            if (!Utilities.isNullOrWhitespace(data.Number)) {
                replaceString = Token.getReplacementString(data.Number, options);
            }
            break;
        case Token.Invoice.Status:
            switch (data.Status) {
                case 1:
                    if (options && options.open == 'true') {
                        replaceString = Token.getReplacementString('Open', options);
                    }
                    break;
                case 2:
                    if (options && options.approval == 'true') {
                        replaceString = Token.getReplacementString('On Approval', options);
                    }
                    break;
                case 3:
                    if (options && options.closed == 'true') {
                        replaceString = Token.getReplacementString('Closed', options);
                    }
                    break;
                case 4:
                    if (options && options.declined == 'true') {
                        replaceString = Token.getReplacementString('Declined', options);
                    }
                    break;
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = () => {
    const invoiceStatusToken = Token.getWrappedTokenConfig('Invoice Status', Token.Invoice.Status);
    invoiceStatusToken.options.push(
        { defaultValue: 'false', label: 'Open', name: 'open', type: 'toggle-small' },
        { defaultValue: 'true', label: 'On Approval', name: 'approval', type: 'toggle-small' },
        { defaultValue: 'false', label: 'Closed', name: 'closed', type: 'toggle-small' },
        { defaultValue: 'false', label: 'Declined', name: 'declined', type: 'toggle-small' }
    );
    return [
        Token.getWrappedTokenConfig('Invoice Number', Token.Invoice.Number),
        invoiceStatusToken
    ]
};
const TypeConfig = {
    panel: {
        block: () => LabelValueTypeConfig.panel.block('3'),
        description: () => LabelValueTypeConfig.panel.description(Utilities.wrapTextForEditor({ text: `{${Token.Invoice.Status}("before":"","after":"","open":"false","approval":"true","closed":"false","declined":"false")}`, token: Token.Invoice.Status })),
        label: () => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: 'Invoice #' })),
        style: LabelValueTypeConfig.panel.style,
        value: () => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Invoice.Number}("before":"","after":"")}`, token: Token.Invoice.Number }))
    }
};

// #endregion NUMBER

export {
    Number as Component,
    Tokens,
    TypeConfig
}